import Vue from 'vue';

// main.js includes global styles, polyfills, shared scripts, i18n, and component initialization
import '@/base/global-js/main.js';
// import '@/base/global-js/LazyImage.js';
import '@/base/global-js/LazyTrigger.js';
import '@/base/global-js/Tooltip.js';
import '@/base/global-js/TogglePanel.js';

// Component dependencies

import EbirdHome from './EbirdHome.vue';

import ConservationStatus from './ConservationStatus.vue';
Vue.component('ConservationStatus', ConservationStatus);

import MyActivityBadges from './MyActivityBadges.vue';
Vue.component('MyActivityBadges', MyActivityBadges);

import SpeciesAudioPlaylist from './SpeciesAudioPlaylist.vue';
Vue.component('SpeciesAudioPlaylist', SpeciesAudioPlaylist);

import SpeciesPage from './SpeciesPage.vue';
Vue.component('SpeciesPage', SpeciesPage);

import ChecklistReportLightbox from './ChecklistReportLightbox.vue';
Vue.component('ChecklistReportLightbox', ChecklistReportLightbox);

import ChecklistReportMedia from './ChecklistReportMedia.vue';
Vue.component('ChecklistReportMedia', ChecklistReportMedia);

import ChecklistReportChecklistMedia from './ChecklistReportChecklistMedia.vue';
Vue.component('ChecklistReportChecklistMedia', ChecklistReportChecklistMedia);

import ProjectJoin from './ProjectJoin.vue';
Vue.component('ProjectJoin', ProjectJoin);

import ChecklistFeaturedMedia from './ChecklistFeaturedMedia.vue';
Vue.component('ChecklistFeaturedMedia', ChecklistFeaturedMedia);

// base
import CloSkipTo from '@/base/CloSkipTo/CloSkipTo';
Vue.component('CloSkipTo', CloSkipTo);

import CloBadge from '@/base/CloBadge/CloBadge';
Vue.component('CloBadge', CloBadge);

import CloButton from '@/base/CloButton/CloButton';
Vue.component('CloButton', CloButton);

import CloDialog from '@/base/CloDialog/CloDialog';
Vue.component('CloDialog', CloDialog);

import CloDivider from '@/base/CloDivider/CloDivider';
Vue.component('CloDivider', CloDivider);

import CloDropdown from '@/base/CloDropdown/CloDropdown';
Vue.component('CloDropdown', CloDropdown);

import CloHeading from '@/base/CloHeading/CloHeading';
Vue.component('CloHeading', CloHeading);

import CloPage from '@/base/CloPage/CloPage';
Vue.component('CloPage', CloPage);

import CloTable from '@/base/CloTable/CloTable';
Vue.component('CloTable', CloTable);

import CloUnorderedList from '@/base/CloUnorderedList/CloUnorderedList';
Vue.component('CloUnorderedList', CloUnorderedList);

// forms
import CloSuggest from '@/forms/CloSuggest/CloSuggest';
Vue.component('CloSuggest', CloSuggest);

// grid
import CloGridFlex from '@/grid/CloGridFlex/CloGridFlex';
Vue.component('CloGridFlex', CloGridFlex);

// grid auto
import CloGridAuto from '@/grid/CloGridAuto/CloGridAuto';
Vue.component('CloGridAuto', CloGridAuto);

// icons
import CloIcon from '@/icons/CloIcon/CloIcon';
Vue.component('CloIcon', CloIcon);

// layouts

import CloAdvertisement from '@/layouts/CloAdvertisement/CloAdvertisement';
Vue.component('CloAdvertisement', CloAdvertisement);

import CloBlurb from '@/layouts/CloBlurb/CloBlurb';
Vue.component('CloBlurb', CloBlurb);

import CloHero from '@/layouts/CloHero/CloHero';
Vue.component('CloHero', CloHero);

import CloLogosGrid from '@/layouts/CloLogosGrid/CloLogosGrid';
Vue.component('CloLogosGrid', CloLogosGrid);

import CloMessage from '@/layouts/CloMessage/CloMessage';
Vue.component('CloMessage', CloMessage);

import CloObservation from '@/layouts/CloObservation/CloObservation';
Vue.component('CloObservation', CloObservation);

import CloSupporters from '@/layouts/CloSupporters/CloSupporters';
Vue.component('CloSupporters', CloSupporters);

import CloSectionHeading from '@/layouts/CloSectionHeading/CloSectionHeading';
Vue.component('CloSectionHeading', CloSectionHeading);

import CloSectionMenu from '@/layouts/CloSectionMenu/CloSectionMenu';
Vue.component('CloSectionMenu', CloSectionMenu);

// maps
import CloMapGoogle from '@/maps/CloMapGoogle/CloMapGoogle';
Vue.component('CloMapGoogle', CloMapGoogle);

// media
import CloCarouselResponsive from '@/media/CloCarouselResponsive/CloCarouselResponsive';
Vue.component('CloCarouselResponsive', CloCarouselResponsive);

import CloImageAspectRatio from '@/media/CloImageAspectRatio/CloImageAspectRatio';
Vue.component('CloImageAspectRatio', CloImageAspectRatio);

import CloMedia from '@/media/CloMedia/CloMedia';
Vue.component('CloMedia', CloMedia);

import CloMediaCredit from '@/media/CloMediaCredit/CloMediaCredit';
Vue.component('CloMediaCredit', CloMediaCredit);

import CloMediaFeed from '@/media/CloMediaFeed/CloMediaFeed';
Vue.component('CloMediaFeed', CloMediaFeed);

import CloResultsGallery from '@/media/CloResultsGallery/CloResultsGallery';
Vue.component('CloResultsGallery', CloResultsGallery);

// navigation
import CloHeader from '@/navigation/CloHeader/CloHeader.vue';
Vue.component('CloHeader', CloHeader);

// import CloHeaderIdentity from '@/navigation/CloHeader/CloHeaderIdentity.vue';
// Vue.component('CloHeaderIdentity', CloHeaderIdentity);

// import CloHeaderGroup from '@/navigation/CloHeader/CloHeaderGroup.vue';
// Vue.component('CloHeaderGroup', CloHeaderGroup);

// import CloHeaderList from '@/navigation/CloHeader/CloHeaderList.vue';
// Vue.component('CloHeaderList', CloHeaderList);

// import CloHeaderListItem from '@/navigation/CloHeader/CloHeaderListItem.vue';
// Vue.component('CloHeaderListItem', CloHeaderListItem);

import CloFooter from '@/navigation/CloFooter/CloFooter.vue';
Vue.component('CloFooter', CloFooter);

// import CloFooterBadges from '@/navigation/CloFooter/CloFooterBadges.vue';
// Vue.component('CloFooterBadges', CloFooterBadges);

// import CloFooterList from '@/navigation/CloFooter/CloFooterList.vue';
// Vue.component('CloFooterList', CloFooterList);

// import CloFooterListHeading from '@/navigation/CloFooter/CloFooterListHeading.vue';
// Vue.component('CloFooterListHeading', CloFooterListHeading);

// import CloFooterListItem from '@/navigation/CloFooter/CloFooterListItem.vue';
// Vue.component('CloFooterListItem', CloFooterListItem);

// import CloFooterSocial from '@/navigation/CloFooter/CloFooterSocial.vue';
// Vue.component('CloFooterSocial', CloFooterSocial);


import CloBreadcrumbs from '@/navigation/CloBreadcrumbs/CloBreadcrumbs';
Vue.component('CloBreadcrumbs', CloBreadcrumbs);

import CloToolbar from '@/navigation/CloToolbar/CloToolbar';
Vue.component('CloToolbar', CloToolbar);

// visualizations
import CloStatList from '@/visualizations/CloStatList/CloStatList';
Vue.component('CloStatList', CloStatList);

import CloStat from '@/visualizations/CloStat/CloStat';
Vue.component('CloStat', CloStat);

// deprecated
import CloHeaderBeta from '@/deprecated/CloHeaderBeta';
Vue.component('CloHeaderBeta', CloHeaderBeta);

import CloPanel from '@/deprecated/CloPanel';
Vue.component('CloPanel', CloPanel);

// wordpress
import CloWordpress from '@/wordpress/CloWordpress/CloWordpress';
Vue.component('CloWordpress', CloWordpress);

// local Submit components
import SubmitProjects from '../submit/components/SubmitProjects.vue';
Vue.component('SubmitProjects', SubmitProjects);

import ProjectCard from '../submit/components/ProjectCard.vue';
Vue.component('ProjectCard', ProjectCard);

import MediaLicenseAgreement from '../shared/MediaLicenseAgreement.vue';
Vue.component('MediaLicenseAgreement', MediaLicenseAgreement);